(function () {
  var GLYPHS = '01#/\\<>_=+~*%&$@[]|';
  function noise() { return GLYPHS.charAt(Math.floor(Math.random() * GLYPHS.length)); }

  function init(root) {
    if (!root || root.dataset.miReady) return;
    root.dataset.miReady = '1';
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var titleEl = root.querySelector('[data-mi-text]');
    var numEl = root.querySelector('[data-mi-num]');
    var animHead = root.dataset.headAnim === 'true' && !reduce && !!titleEl;
    var animCount = root.dataset.countAnim === 'true' && !reduce && !!numEl;
    if (!animHead && !animCount) return;

    var TITLE = titleEl ? titleEl.textContent : '';
    var busy = false, inView = false, started = false;

    function build() {
      titleEl.textContent = '';
      var out = [];
      var words = TITLE.split(' ');
      words.forEach(function (word, wi) {
        var w = document.createElement('span');
        w.className = 'mi__w';
        word.split('').forEach(function (ch) {
          var c = document.createElement('span');
          c.className = 'mi__c';
          c.textContent = ch;
          w.appendChild(c);
          out.push({ el: c, ch: ch });
        });
        titleEl.appendChild(w);
        if (wi < words.length - 1) titleEl.appendChild(document.createTextNode(' '));
      });
      out.forEach(function (s) { s.w = s.el.getBoundingClientRect().width; });
      out.forEach(function (s) { s.el.style.width = s.w + 'px'; });
      return out;
    }

    function play(mode, done) {
      if (busy) return;
      busy = true;
      var chars = build();
      root.classList.remove('mi--prep');
      var n = chars.length, plan = [], i;
      if (mode === 'decode') {
        var step = Math.min(38, 1000 / Math.max(n, 1));
        for (i = 0; i < n; i++) plan[i] = chars[i].ch.trim() ? 240 + i * step + Math.random() * 140 : 0;
      } else {
        var pool = [];
        for (i = 0; i < n; i++) { plan[i] = 0; if (chars[i].ch.trim()) pool.push(i); }
        var hits = Math.min(pool.length, 2 + Math.floor(Math.random() * 2));
        while (hits--) {
          var k = pool.splice(Math.floor(Math.random() * pool.length), 1)[0];
          plan[k] = 200 + Math.random() * 140;
        }
      }
      chars.forEach(function (c, idx) {
        if (plan[idx]) { c.el.textContent = noise(); c.el.classList.add('is-noise'); }
      });
      var t0 = performance.now();
      function frame(now) {
        var elapsed = now - t0, live = false;
        chars.forEach(function (c, idx) {
          var end = plan[idx];
          if (!end || c.done) return;
          if (elapsed < end) {
            live = true;
            if (now - (c.last || 0) > 55) { c.last = now; c.el.textContent = noise(); }
          } else {
            c.done = true;
            c.el.textContent = c.ch;
            c.el.classList.remove('is-noise');
          }
        });
        if (live) { requestAnimationFrame(frame); }
        else { titleEl.textContent = TITLE; busy = false; if (done) done(); }
      }
      requestAnimationFrame(frame);
    }

    function schedule() {
      setTimeout(function () {
        if (!document.body.contains(root)) return;
        if (!document.hidden && inView) play('glitch');
        schedule();
      }, 8000 + Math.random() * 5000);
    }

    function countUp() {
      var target = parseInt(numEl.dataset.n, 10) || 0, t0 = null, dur = 800;
      function tick(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1);
        numEl.textContent = p < 1 ? Math.round(target * (1 - Math.pow(1 - p, 3))) : target;
        if (p < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }

    function start() {
      if (started) return;
      started = true;
      var go = function () {
        if (animHead) play('decode', schedule);
        if (animCount) countUp();
      };
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(go); else go();
    }

    if (animHead) root.classList.add('mi--prep');
    if (animCount) numEl.textContent = '0';

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        if (inView) start();
      }, { threshold: 0.25 }).observe(root);
    } else {
      inView = true;
      start();
    }
  }

  function initAll(scope) {
    [].slice.call((scope || document).querySelectorAll('[data-mi]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();